import React, { useState } from "react";
import "../../Assets/Css/RecentMovieSection.css";
import MovieTrailerPopup from "../../Components/MovieTrailerPopup/MovieTrailerPopup";
import poster1 from "../../Assets/Images/Poster 1.png";
import poster2 from "../../Assets/Images/Poster 2.png";
import poster3 from "../../Assets/Images/Poster 3.png";
import poster4 from "../../Assets/Images/Poster 4.png";
import BG1 from "../../Assets/Images/Movie1BG.png";
import BG2 from "../../Assets/Images/Movie2BG.png";
import BG3 from "../../Assets/Images/Movie3BG.png";
import BG4 from "../../Assets/Images/Movie4BG.png";

const RecentMovieSection = () => {
  const [selectedMovie, setSelectedMovie] = useState(null);

  const movies = [
    {
      poster: poster1,
      title: "Sardar",
      subtitle: "2022",
      description:
        "A thrilling spy action film featuring Karthi in dual roles. Sardar was widely appreciated for its engaging story and action sequences, marking another milestone in Prince Pictures legacy.",
      background: BG1,
      button: ["aha"],
      link: "https://www.youtube.com/watch?v=8OQzz_i3KFE",
      ottLink: "https://www.aha.video/movie/sardar-tamil", 
    },
    {
      poster: poster2,
      title: "Lubber Pandhu",
      subtitle: "2024",
      description:
        "Lubber Pandhu is a high-octane sports drama packed with intense emotions and gripping action. Blending the raw energy of street cricket with an inspiring underdog story, the film promises to keep audiences on the edge of their seats. With a compelling narrative and breathtaking visuals, Lubber Pandhu adds another exciting chapter to  Prince Picture’s legacy",
      background: BG2,
      button: ["jio"],
      link: "https://www.youtube.com/watch?v=oP88LHBukW8",
      ottLink: "https://www.hotstar.com/in/movies/lubber-pandhu/1271335839", 
    },
    {
      poster: poster3,
      title: "Mr. X",
      subtitle: "Upcoming Movie",
      description:
        "In the upcoming Tamil action thriller Mr. X, Arya takes on the lead role, delivering a performance that promises to be both intense and captivating. Directed by Manu Anand, the film also features Gautham Karthik, Manju Warrier, and R. Sarathkumar in pivotal roles. Produced by Prince Pictures, Mr. X is set to release in December 2025. ",
      background: BG3,
      button: [" "],
      link: "",
      ottLink: "", 
    },
    {
      poster: poster4,
      title: "Mannangatti: Since 1960",
      subtitle: "Upcoming Movie",
      description:
        "Mannangatti: Since 1960 is a forthcoming Tamil social comedy-drama that delves into contemporary issues with a satirical lens. Directed by debutant Dude Vicky, the film stars Lady Superstar Nayanthara in the lead role, With its engaging storyline and stellar cast, It is poised to be a significant addition to Prince Pictures legacy of impactful cinema.",
      background: BG4,
      button: [" "],
      link: "",
      ottLink: "", 
    },
  ];

  const handleCardClick = (movie) => {
    setSelectedMovie(movie);
  };

  const closePopup = () => {
    setSelectedMovie(null);
  };

  return (
    <div className="recent-movie-outer">
      <div className="recent-movie-section">
        <h2 className="section-title">Recent Hits & Upcoming Blockbusters</h2>
        <div className="movie-grid">
          {movies.map((movie, index) => (
            <div
              key={index}
              className="movie-card"
              onClick={() => handleCardClick(movie)}
            >
              <img
                src={movie.poster}
                alt={movie.title}
                className="movie-poster"
              />
              <h3 className="movie-title">{movie.title}</h3>
              <p className="movie-subtitle">{movie.subtitle}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Conditional Rendering of the Popup */}
      {selectedMovie && (
        <MovieTrailerPopup movie={selectedMovie} onClose={closePopup} />
      )}
    </div>
  );
};

export default RecentMovieSection;
